import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import LocalizedStrings from 'react-localization';
import moment from 'moment-timezone';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';
import { SetComponentLanguage } from '../../../../helpers';
import SearchResultsTransaction from '../SearchResultsTransaction/SearchResultsTransaction';
import editIcon from '../../../../images/icons/edit-white.svg';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './SearchResultsCustomer.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class SearchResultsCustomer extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isArchivedOpen: false,
            isLoading: false,
            transactions: []
        }
    }

    toggleArchived = (e) => {
        this.props.toggleArchived(e);
        
        this.setState({
            isArchivedOpen: !this.state.isArchivedOpen
        });
        /* this.setState({
            isLoading: true
        });

        setTimeout(() => {
            this.setState({
                isLoading: false
            });
        }, 1000); */
    }

    transactionArchived(param){
        return (
            (param.customer.archives.map((archive, i) => 
                <SearchResultsTransaction
                    key={`transaction-archived-${i}`} 
                    events={this.props.events}
                    user={this.props.user}
                    transaction={archive}
                    archived={true}
                    isTicketFiltered={this.props.isTicketFiltered}
                    updateSelectedIds={this.props.updateSelectedIds}
                    printers={this.props.printers}
                    currentPrinter={this.props.currentPrinter}
                    handlePrinterChange={this.props.handlePrinterChange}
                    handlePrinterChangeBoca={this.props.handlePrinterChangeBoca}
                    printersBoca={this.props.printersBoca}
                    currentPrinterBoca={this.props.currentPrinterBoca}
                    printersStar={this.props.printersStar}
                    printersStarUSB={this.props.printersStarUSB}
                    currentPrinterStar={this.props.currentPrinterStar}
                    handlePrinterChangeStar={this.props.handlePrinterChangeStar}
                    eventsResults={this.props.eventsResults}
                    isGodMode={this.props.isGodMode}
                />
            ))
        )
    }

    render() {
        let addressString = '';
        if(this.props.customer.address_1 !== ''){
            addressString += this.props.customer.address_1 + ', ';
        }
        if(this.props.customer.address_2 !== ''){
            addressString += this.props.customer.address_2 + ', ';
        }
        if(this.props.customer.city !== ''){
            addressString += this.props.customer.city + ', ';
        }
        if(this.props.customer.state !== ''){
            addressString += this.props.customer.state + ', ';
        }
        if(this.props.customer.country !== ''){
            addressString += this.props.customer.country + ', ';
        }
        if(this.props.customer.zip !== ''){
            addressString += this.props.customer.zip + ', ';
        }
        if(this.props.customer.phone !== ''){
            addressString += this.props.customer.phone + ', ';
        }
        if(this.props.customer.email !== ''){
            addressString += this.props.customer.email;
        }
        
        return (   
            <tr>                
                <td colSpan="2">
                    <div className="showtix-search__customer">
                        {!this.props.customer.is_box_office ? 
                            (
                                <React.Fragment>
                                    <Link className="showtix-search__edit" to={`/create-customer/${this.props.customer.id}`} target="_blank" rel="noopener">
                                        <img src={editIcon} alt="Edit" />
                                    </Link>
                                    <span id={`tooltip-customer-${this.props.customer.id}`} className="showtix-tooltip">!</span>
                                    <Tooltip placement="top" target={`tooltip-customer-${this.props.customer.id}`}>
                                        {strings.customerCreated} {moment.utc(this.props.customer.created).format('dddd MMMM Do, YYYY h:mm A')}
                                    </Tooltip>
                                    {this.props.customer.first_name} {this.props.customer.last_name}
                                    <br />
                                    {addressString}
                                </React.Fragment>
                            )
                        :
                            (
                                <React.Fragment>
                                    {strings.boxOffice}
                                </React.Fragment>    
                            )
                        }
                        
                    </div>
                    { !this.props.isTransactionInfoHidden &&
                        <div>
                            { this.props.customer.transactions.map((transaction, i) =>
                                <SearchResultsTransaction
                                    key={`transaction-${i}`} 
                                    client={this.props.client}
                                    events={this.props.events}
                                    user={this.props.user}
                                    transaction={transaction}
                                    archived={false}
                                    toggleAlertModal={this.props.toggleAlertModal}
                                    toggleReleaseRefundModal={this.props.toggleReleaseRefundModal}
                                    updateSelectedIds={this.props.updateSelectedIds}
                                    setMessage={this.props.setMessage}
                                    printers={this.props.printers}
                                    currentPrinter={this.props.currentPrinter}
                                    handlePrinterChange={this.props.handlePrinterChange}
                                    printersBoca={this.props.printersBoca}
                                    currentPrinterBoca={this.props.currentPrinterBoca}
                                    handlePrinterChangeBoca={this.props.handlePrinterChangeBoca}
                                    printersStar={this.props.printersStar}
                                    printersStarUSB={this.props.printersStarUSB}
                                    currentPrinterStar={this.props.currentPrinterStar}
                                    handlePrinterChangeStar={this.props.handlePrinterChangeStar}
                                    eventsResults={this.props.eventsResults}
                                    isGodMode={this.props.isGodMode}
                                />
                            )}

                            <div className="showtix-search__archived-transactions">
                                <button 
                                    className="showtix-button showtix-button__small showtix-background__grey-3"
                                    onClick={this.toggleArchived}
                                    id={this.props.customer.id}
                                >
                                    {strings.archivedTransactions}
                                </button>

                                { this.state.isLoading && 
                                    <div className="showtix-loader">Loading...</div>
                                }

                                <div className={"showtix-search__archived-transactions__results " + (this.state.isArchivedOpen ? 'is-active' : '')}>
                                    { this.props.customer.archives &&
                                        this.transactionArchived(this.props)
                                    }
                                </div>
                            </div>
                        </div>        
                    }  
                </td>
            </tr>
        )
    }
}

SearchResultsCustomer.propTypes = {
    user: PropTypes.object,
    transaction: PropTypes.shape({
        customer: PropTypes.shape({
            id: PropTypes.number,
            phone: PropTypes.string,
            first_name: PropTypes.string,
            last_name: PropTypes.string,
            address_1: PropTypes.string,
            address_2: PropTypes.string,
            city: PropTypes.string,
            state: PropTypes.string,
            country: PropTypes.string,
            zip: PropTypes.string,
            transactions: PropTypes.array,
            transactionsFiltered: PropTypes.array,
        })
    }),
    isTransactionInfoHidden: PropTypes.bool,
    toggleAlertModal: PropTypes.func,
    updateSelectedIds: PropTypes.func
}


export default SearchResultsCustomer;



// WEBPACK FOOTER //
// ./src/components/Search/SearchResults/SearchResultsCustomer/SearchResultsCustomer.js